import protoRoot from "../proto-root";

const name = "stopMonitoringRPCResponse";

function create({ allowsNewConnection }) {
  const StopMonitoringRPCResponse = protoRoot.lookupType(
    "comm.StopMonitoringRPCResponse"
  );

  return {
    payload: StopMonitoringRPCResponse.create({ allowsNewConnection }),
    name,
    sendBy: "xmpp"
  };
}

export default {
  create,
  name
};
